"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _LRUCache = _interopRequireDefault(require("./structs/LRUCache.js"));

var _tilecoord = require("./tilecoord.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/TileCache
 */


var TileCache =
/** @class */
function (_super) {
  __extends(TileCache, _super);

  function TileCache() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @param {!Object<string, boolean>} usedTiles Used tiles.
   */


  TileCache.prototype.expireCache = function (usedTiles) {
    while (this.canExpireCache()) {
      var tile = this.peekLast();

      if (tile.getKey() in usedTiles) {
        break;
      } else {
        this.pop().release();
      }
    }
  };
  /**
   * Prune all tiles from the cache that don't have the same z as the newest tile.
   */


  TileCache.prototype.pruneExceptNewestZ = function () {
    if (this.getCount() === 0) {
      return;
    }

    var key = this.peekFirstKey();
    var tileCoord = (0, _tilecoord.fromKey)(key);
    var z = tileCoord[0];
    this.forEach(function (tile) {
      if (tile.tileCoord[0] !== z) {
        this.remove((0, _tilecoord.getKey)(tile.tileCoord));
        tile.release();
      }
    }.bind(this));
  };

  return TileCache;
}(_LRUCache["default"]);

var _default = TileCache;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBSkE7Ozs7O0FBTUE7QUFBQTtBQUFBO0VBQXdCQTs7RUFBeEI7O0VBa0NDO0VBakNDOzs7OztFQUdBQyw0Q0FBWUMsU0FBWixFQUFxQjtJQUNuQixPQUFPLEtBQUtDLGNBQUwsRUFBUCxFQUE4QjtNQUM1QixJQUFNQyxJQUFJLEdBQUcsS0FBS0MsUUFBTCxFQUFiOztNQUNBLElBQUlELElBQUksQ0FBQ0UsTUFBTCxNQUFpQkosU0FBckIsRUFBZ0M7UUFDOUI7TUFDRCxDQUZELE1BRU87UUFDTCxLQUFLSyxHQUFMLEdBQVdDLE9BQVg7TUFDRDtJQUNGO0VBQ0YsQ0FURDtFQVdBOzs7OztFQUdBUDtJQUNFLElBQUksS0FBS1EsUUFBTCxPQUFvQixDQUF4QixFQUEyQjtNQUN6QjtJQUNEOztJQUNELElBQU1DLEdBQUcsR0FBRyxLQUFLQyxZQUFMLEVBQVo7SUFDQSxJQUFNQyxTQUFTLEdBQUcsd0JBQVFGLEdBQVIsQ0FBbEI7SUFDQSxJQUFNRyxDQUFDLEdBQUdELFNBQVMsQ0FBQyxDQUFELENBQW5CO0lBQ0EsS0FBS0UsT0FBTCxDQUNFLFVBQVVWLElBQVYsRUFBYztNQUNaLElBQUlBLElBQUksQ0FBQ1EsU0FBTCxDQUFlLENBQWYsTUFBc0JDLENBQTFCLEVBQTZCO1FBQzNCLEtBQUtFLE1BQUwsQ0FBWSx1QkFBT1gsSUFBSSxDQUFDUSxTQUFaLENBQVo7UUFDQVIsSUFBSSxDQUFDSSxPQUFMO01BQ0Q7SUFDRixDQUxELENBS0VRLElBTEYsQ0FLTyxJQUxQLENBREY7RUFRRCxDQWZEOztFQWdCRjtBQUFDLENBbENELENBQXdCQyxvQkFBeEI7O2VBb0NlaEIsUyIsIm5hbWVzIjpbIl9fZXh0ZW5kcyIsIlRpbGVDYWNoZSIsInVzZWRUaWxlcyIsImNhbkV4cGlyZUNhY2hlIiwidGlsZSIsInBlZWtMYXN0IiwiZ2V0S2V5IiwicG9wIiwicmVsZWFzZSIsImdldENvdW50Iiwia2V5IiwicGVla0ZpcnN0S2V5IiwidGlsZUNvb3JkIiwieiIsImZvckVhY2giLCJyZW1vdmUiLCJiaW5kIiwiTFJVQ2FjaGUiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL1RpbGVDYWNoZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==